export function getMessageTemplateSelectApiData({ data }) {
  return data.objects
}

export function toMessageTemplateSelectItem(item) {
  return {
    label: item.name,
    value: item.id,
  }
}

export function toMessageTemplateSelectItems(
  items,
  mapper = toMessageTemplateSelectItem
) {
  return items.map(mapper)
}
